import {
  Button,
  Col,
  Divider,
  Drawer,
  Form,
  Input,
  Modal,
  notification,
  Row,
  Select,
  Space,
  Spin,
  Upload,
} from "antd";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import {
  Checkbox1,
  Date2,
  Date4,
  Select4,
  Text4,
} from "../../../Components/FormComponents/InputFields";
import { MdInbox } from "react-icons/md";
import { HiDownload } from "react-icons/hi";
import employeeTemplate from "../../../Assets/Files/sample_employee_excel.xlsx";
import { download } from "../../../Services/GeneralFunctions";
import { LoadingOutlined } from "@ant-design/icons";
import FormHeading from "../../../Components/FormComponents/FormHeading";
import {
  useLocation,
  useNavigate,
  useOutletContext,
  useParams,
} from "react-router-dom";
import {
  AddEmployeeApi,
  ApiKycSubmit,
  ExcelUploadApi,
  GetOtpAPI,
  VerifyOtpAPI,
  VerifyPanAPI,
} from "../../../Services/EmployeeManager";
import { GetSingleEmployeeData } from "../../../Services/CommonApis";

const { Dragger } = Upload;
const { Option } = Select;

export default function AddEmployee() {
  const { dropDowns } = useOutletContext();
  const navigate = useNavigate();

  const {
    control,
    formState: { errors },
    handleSubmit,
    reset,
  } = useForm();
  const [api, contextHolder] = notification.useNotification();
  const location = useLocation();
  const pageType = location.state?.type;
  const [fileList, setFileList] = useState([]);
  const [toggleDisable, setToggleDisable] = useState(false);
  const [genderValue, setGenderValue] = useState(null);
  const [newEmp, setNewEmp] = useState(pageType === "new" ? true : false);
  const [getdata, setGetdata] = useState(false);

  const [submitLoader, setSubmitLoader] = useState(false);
  const [aadharData, setAadharData] = useState({
    aadhar_num: "",
    mobile: "",
    _id: "",
  });
  const [aadhaarRes, setAadhaarRes] = useState();
  const [aadhaarStatus, setAadhaarStatus] = useState("ok");
  const [aadhaarReason, setAadhaarReason] = useState("");

  const [panStatus, setPanStatus] = useState("ok");
  const [panReason, setPanReason] = useState("");
  const [otp, setOtp] = useState("");
  const [step, setStep] = useState("get_otp");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isModalVisible2, setIsModalVisible2] = useState(false);

  const titleDropDown = {
    Female: dropDowns
      ? dropDowns.TITLE.filter((val) => val.value !== "Mr.")
      : [],
    Male: dropDowns ? dropDowns.TITLE.filter((val) => val.value === "Mr.") : [],
    Other: dropDowns ? dropDowns.TITLE : [],
  };

  const getSingleEmployee = async (id) => {
    try {
      const { data } = await GetSingleEmployeeData(id);
      console.log(data);
      if (data?.success) {
        console.log(data?.data);
        setGetdata(data?.data);
      } else {
        api.error({
          message: "Error while Fetching employee Details",
          description: data?.message,
          placement: "top",
        });
      }
    } catch (err) {
      api.error({
        message: err.message,
        description: "Try to Check your Internet Connection.",
        placement: "top",
      });
    }
  };

  const onSubmit = async (val) => {
    console.log(val, newEmp);
    try {
      const data = await AddEmployeeApi(val, newEmp);
      console.log(data);

      if (data.data.success) {
        api.success({
          message: data.data.message,
          placement: "top",
        });
        if (pageType === "new") {
          await handleVerifypan(val.panNumber, data?.data?.inserted_id);
          setAadharData({
            aadhar_num: val.aadharNumber,
            mobile: val.mobile || "",
            _id: data?.data?.inserted_id,
          });
          setIsModalVisible(true);
        } else {
          navigate("/admin/employees-manager");
        }
      } else {
        api.error({
          message: data.data.message,
          placement: "top",
        });
      }
    } catch (err) {
      api.error({
        message: err.message,
        description: "Try to check your Internet Connection",
        placement: "top",
      });
    }
  };

  const handleVerifypan = async (pan_card, inserted_id) => {
    try {
      const response = await VerifyPanAPI(pan_card, inserted_id);
      if (!response?.data?.success) {
        console.log(response);
        api.error({ message: response?.data?.message, placement: "top" });
      }
    } catch (error) {
      console.error("PAN verification failed:", error);
    }
  };

  const handleGetOtp = async () => {
    setSubmitLoader(true);
    try {
      const response = await GetOtpAPI(aadharData);
      console.log(response);
      if (response?.data?.success) {
        setSubmitLoader(false);

        setAadhaarRes(response?.data?.message);

        setStep("verify_otp");
        api.success({ message: "OTP sent successfully", placement: "top" });
      } else {
        api.error({ message: response?.data?.message, placement: "top" });
      }
      setSubmitLoader(false);
    } catch (err) {
      setSubmitLoader(false);

      api.error({ message: "Failed to send OTP", placement: "top" });
    }
  };

  const handleVerifyOtp = async () => {
    try {
      setSubmitLoader(true);

      const response = await VerifyOtpAPI(aadhaarRes, aadharData, otp);
      console.log(response);
      if (response?.data?.success) {
        setSubmitLoader(false);

        api.success({
          message: "Aadhar verified successfully",
          placement: "top",
        });
        setIsModalVisible(false);
        setOtp("");
        setStep("get_otp");
        setIsModalVisible2(true);
        getSingleEmployee(aadharData?._id);
        // navigate("/admin/employees-manager");
      } else {
        api.error({ message: response?.data?.message, placement: "top" });
        navigate("/admin/employees-verification");
      }
      setSubmitLoader(false);
    } catch (err) {
      api.error({ message: "OTP verification failed", placement: "top" });
      setSubmitLoader(false);
    }
  };

  const handleKycSubmit = async () => {
    try {
      const payload = {
        _id: aadharData._id,
        aadhar_verified: aadhaarStatus === "ok",
        pan_verified: panStatus === "ok",
        ...(aadhaarStatus === "deviation" && {
          aadhar_deviation: aadhaarReason,
        }),
        ...(panStatus === "deviation" && { pan_deviation: panReason }),
      };

      const res = await ApiKycSubmit(payload);

      if (res.data.success) {
        api.success({ message: `KYC Submitted`, placement: "top" });
        setIsModalVisible2(false);
        navigate("/admin/employees-verification");
      } else {
        api.error({ message: res.data.message, placement: "top" });
      }
    } catch (err) {
      console.log(err, "checking error");
      // api.error({ message: "KYC verification failed", placement: "top" });
    }
  };
  const handleExcelSubmit = async () => {
    let formData = new FormData();
    formData.append("employee_list", fileList[0]);

    try {
      setSubmitLoader(true);
      const data = await ExcelUploadApi(formData, newEmp);
      setSubmitLoader(false);

      console.log(data);
      if (data.statusText === "OK") {
        api.success({
          message: "File is Submitted Successfully!",
          description: "Please Check the Downloaded Result File for Status.",
          placement: "top",
        });
        // download(new Blob([data.data], {type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;"}), 'result.xlsx');
        download(new Blob([data.data], { type: "text/csv" }), "result.csv");
        navigate("/admin/employees-verification");
      }
    } catch (err) {
      setSubmitLoader(false);

      api.error({
        message: err.message,
        placement: "top",
      });
    }
  };

  const onExcelUpload = (temp, val) => {
    setToggleDisable(true);
    reset();

    if (
      val[0].type ===
        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" ||
      val[0].type === "application/vnd.ms-excel"
    ) {
      setFileList(val);
      return false;
    } else {
      return Upload.LIST_IGNORE;
    }
  };

  return (
    <>
      {contextHolder}

      <section className="bg-white p-3 shadow-sm border border-gray-200 w-full rounded-2xl flex items-center justify-between mb-3">
        <h2 className="text-2xl font-semibold text-gray-900">
          {pageType === "new" ? "Add New Employee" : "Add Employee"}
        </h2>
      </section>

      <section className="bg-white p-4 pt-2 shadow-md border border-gray-900 w-full rounded-2xl mb-2">
        <Col className={`px-3 my-4 text-justify`} span={24}>
          <h2 class="text-[#00a0e4] font-bold text-xl flex items-center">
            <span class="w-1 h-full bg-[#00a0e4] mr-2">|</span>
            Personal Details
          </h2>
        </Col>
        {/* <Checkbox1
          control={control}
          errors={errors}
          id="newEmpCheckbox"
          name="For New Employee"
          onChange={(val) => setNewEmp(val.target.checked)}
          defaultChecked={newEmp}
          disabled={toggleDisable}
        /> */}
        <Row>
          <Select4
            control={control}
            errors={errors}
            id="gender"
            name="Gender"
            disabled={toggleDisable}
            validations={{ required: true }}
            options={dropDowns && dropDowns.GENDER}
            onChange={(val) => setGenderValue(val)}
          />
          <Select4
            control={control}
            errors={errors}
            id="title"
            name="Title"
            disabled={toggleDisable}
            validations={{ required: true }}
            options={titleDropDown[genderValue]}
          />

          <Text4
            control={control}
            errors={errors}
            id="firstName"
            name="First Name"
            disabled={toggleDisable}
            validations={{ required: true }}
          />
          <Text4
            control={control}
            errors={errors}
            id="middleName"
            name="Middle Name"
            disabled={toggleDisable}
          />

          <Text4
            control={control}
            errors={errors}
            id="lastName"
            name="Last Name"
            disabled={toggleDisable}
            validations={{ required: true }}
          />
          <Date4
            control={control}
            errors={errors}
            id="dob"
            name="Date of Birth"
            validations={{ required: true }}
            disabled={toggleDisable}
          />

          <Text4
            control={control}
            errors={errors}
            id="mobile"
            name="Mobile"
            disabled={toggleDisable}
            validations={{ required: true }}
            type="tel"
            maxLength={10}
          />
          <Text4
            control={control}
            errors={errors}
            id="emergencyContact"
            name="Emergency Contact"
            disabled={toggleDisable}
            type="tel"
            maxLength={10}
          />

          <Select4
            control={control}
            errors={errors}
            id="bloodGroup"
            name="Blood Group"
            disabled={toggleDisable}
            options={dropDowns && dropDowns.BLOOD_GROUP}
          />
          <Text4
            control={control}
            errors={errors}
            id="personalEmail"
            name="Personal Email"
            disabled={toggleDisable}
            validations={{ required: true }}
          />

          <Text4
            control={control}
            errors={errors}
            id="aadharNumber"
            name="Aadhar Card Number"
            disabled={toggleDisable}
            validations={{ required: true }}
            type="tel"
            maxLength={12}
          />
          <Text4
            control={control}
            errors={errors}
            id="panNumber"
            validations={{ required: true }}
            name="Pan Card Number"
            disabled={toggleDisable}
            maxLength={10}
          />
          <Divider />

          <Col className={`px-3 mb-4 text-justify`} span={24}>
            <h2 class="text-[#00a0e4] font-bold text-xl flex items-center">
              <span class="w-1 h-full bg-[#00a0e4] mr-2">|</span>
              Professional Details
            </h2>
          </Col>
          <Text4
            control={control}
            errors={errors}
            id="employeeId"
            name="Employee ID"
            disabled={toggleDisable}
            validations={{ required: !newEmp }}
          />
          <Text4
            control={control}
            errors={errors}
            id="companyEmail"
            name="Company Email"
            disabled={toggleDisable}
            validations={{ required: !newEmp }}
          />

          <Date4
            control={control}
            errors={errors}
            id="doj"
            name="Date of Joining"
            validations={{ required: !newEmp }}
            disabled={toggleDisable}
          />
          <Select4
            control={control}
            errors={errors}
            id="company"
            name="Company"
            disabled={toggleDisable}
            validations={{ required: true }}
            options={dropDowns && dropDowns.COMPANY}
          />

          <Select4
            control={control}
            errors={errors}
            id="businessUnit"
            name="Business Unit"
            disabled={toggleDisable}
            validations={{ required: true }}
            options={dropDowns && dropDowns.BUSINESS_UNIT}
          />

          {/* <Select4 control={control} errors={errors}  id='businessUnit' name='Business Unit' disabled={toggleDisable} validations={{ required: true }} options={dropDowns && dropDowns.BUSINESS_UNIT} /> */}
          <Select4
            control={control}
            errors={errors}
            id="function"
            name="Function"
            disabled={toggleDisable}
            validations={{ required: true }}
            options={dropDowns && dropDowns.FUNCTION}
          />

          <Select4
            control={control}
            errors={errors}
            id="corporate"
            name="Corporate"
            disabled={toggleDisable}
            validations={{ required: true }}
            options={dropDowns && dropDowns.CORPORATE}
          />
          {/* <Text4 control={control} errors={errors}  id='corporate' name='Corporate' disabled={toggleDisable} validations={{ required: true }}/> */}
          <Select4
            control={control}
            errors={errors}
            id="office"
            name="Office"
            disabled={toggleDisable}
            validations={{ required: true }}
            options={dropDowns && dropDowns.OFFICE}
          />

          <Select4
            control={control}
            errors={errors}
            id="role"
            name="Role"
            disabled={toggleDisable}
            validations={{ required: newEmp }}
            options={dropDowns && dropDowns.ROLE}
          />

          <Text4
            control={control}
            errors={errors}
            id="designation"
            name="Designation"
            disabled={toggleDisable}
            validations={{ required: true }}
          />
          <Text4
            control={control}
            errors={errors}
            id="managerId"
            name="Reporting Manager ID"
            validations={{ required: !newEmp }}
            disabled={toggleDisable}
          />
          <Date4
            control={control}
            errors={errors}
            id="interviewDate"
            name="Interview Date"
            validations={{ required: true }}
            disabled={toggleDisable}
          />
          <Text4
            control={control}
            errors={errors}
            id="interviewer"
            name="Interviewer Name"
            validations={{ required: false }}
            disabled={toggleDisable}
          />

          <Divider>OR</Divider>

          <a
            href={employeeTemplate}
            download="sample_employees_template"
            className="mb-3"
            style={{ width: "100%" }}
          >
            <Button block size="large" className="flex justify-center">
              <HiDownload className="fs-5 mx-2" />
              <span> Sample Excel Template</span>
            </Button>
          </a>
          {/* 
          <Checkbox1
            control={control}
            errors={errors}
            id="newEmpCheckbox"
            name="For New Employee"
            onChange={(val) => setNewEmp(val.target.checked)}
            defaultChecked={newEmp}
            disabled={toggleDisable}
          /> */}

          <Dragger
            className="w-100"
            beforeUpload={onExcelUpload}
            listType="picture"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            maxCount={1}
            fileList={fileList}
            onRemove={() => {
              setFileList([]);
              setToggleDisable(false);
            }}
          >
            <p className="ant-upload-drag-icon flex justify-center">
              <MdInbox className="fs-1 text-info" />
            </p>
            <p className="ant-upload-text">
              Click or drag file to this area to upload
            </p>
            <p className="ant-upload-hint">
              Support for a single excel file.
              <br />
              <br />
              You can download the template excel file to fill employees details
              using button above.
            </p>
          </Dragger>
        </Row>
        <Button
          size="large"
          onClick={toggleDisable ? handleExcelSubmit : handleSubmit(onSubmit)}
          type="primary"
          className={` bg-[#76CAF8] flex  justify-end ${
            toggleDisable ? "mt-20" : "mt-4"
          }`}
          disabled={submitLoader}
        >
          {submitLoader && (
            <Spin
              className="mr-2 mb-2"
              size="default"
              indicator={<LoadingOutlined className="text-light" />}
              spinning={true}
            />
          )}
          Submit
        </Button>
      </section>

      <Modal
        title="Verify Aadhar"
        open={isModalVisible}
        onCancel={() => {
          setIsModalVisible(false);
          setStep("get_otp");
          setOtp("");
        }}
        footer={null}
        maskClosable={false}
        closable={true}
      >
        {step === "get_otp" ? (
          <Form layout="vertical" onFinish={handleGetOtp}>
            <Form.Item label="Aadhar Number">
              <Input
                value={aadharData?.aadhar_num}
                disabled
                // onChange={(e) =>
                //   setAadharData({ ...aadharData, aadhar_num: e.target.value })
                // }
              />
            </Form.Item>
            <Form.Item
              label="Mobile Number"
              name="mobile"
              initialValue={aadharData.mobile}
            >
              <Input
                onChange={(e) =>
                  setAadharData({ ...aadharData, mobile: e.target.value })
                }
              />
            </Form.Item>
            <Button type="primary" htmlType="submit" disabled={submitLoader}>
              {submitLoader && (
                <Spin
                  className="mr-2 mb-2"
                  size="default"
                  indicator={<LoadingOutlined className="text-light" />}
                  spinning={true}
                />
              )}
              Get OTP
            </Button>
          </Form>
        ) : (
          <Form layout="vertical" onFinish={handleVerifyOtp}>
            <Form.Item label="OTP">
              <Input
                value={otp}
                onChange={(e) => setOtp(e.target.value)}
                maxLength={6}
              />
            </Form.Item>
            <Button type="primary" htmlType="submit" disabled={submitLoader}>
              {submitLoader && (
                <Spin
                  className="mr-2 mb-2"
                  size="default"
                  indicator={<LoadingOutlined className="text-light" />}
                  spinning={true}
                />
              )}
              Verify OTP
            </Button>
          </Form>
        )}
      </Modal>
      <Modal
        title="KYC Verification Summary"
        open={isModalVisible2}
        onCancel={() => setIsModalVisible2(false)}
        footer={null}
        maskClosable={false}
        closable={true}
      >
        {getdata ? (
          <div className="space-y-6">
            {/* User Details */}
            <div className="border rounded-lg p-4">
              <h3 className="font-semibold text-lg mb-2">User Details</h3>
              <p>
                <strong>Name:</strong> {getdata?.name?.full_name}
              </p>
              <p>
                <strong>Mobile:</strong> {getdata?.mobile}
              </p>
            </div>

            {/* Aadhaar Details */}
            <div className="border rounded-lg p-4">
              <h3 className="font-semibold text-lg mb-2">Aadhaar Details</h3>
              <p>
                <strong>Aadhaar Number:</strong>{" "}
                {getdata?.aadhar_response_data?.aadhar_number}
              </p>
              <p>
                <strong>Full Name:</strong>{" "}
                {getdata?.aadhar_response_data?.full_name}
              </p>
              <p>
                <strong>Linked Mobile:</strong> {getdata?.mobile}
              </p>

              <div className="mt-3 space-y-2">
                <Select
                  value={aadhaarStatus}
                  onChange={setAadhaarStatus}
                  className="w-full"
                >
                  <Option value="ok">OK</Option>
                  <Option value="deviation">Deviation</Option>
                </Select>
                {aadhaarStatus === "deviation" && (
                  <Input.TextArea
                    placeholder="Enter Aadhaar deviation reason"
                    value={aadhaarReason}
                    onChange={(e) => setAadhaarReason(e.target.value)}
                  />
                )}
              </div>
            </div>

            {/* PAN Details */}
            <div className="border rounded-lg p-4">
              <h3 className="font-semibold text-lg mb-2">PAN Details</h3>
              <p>
                <strong>PAN Number:</strong>{" "}
                {getdata?.pan_response_data?.data?.pan_number}
              </p>
              <p>
                <strong>Name on PAN:</strong>{" "}
                {getdata?.pan_response_data?.data?.full_name}
              </p>

              <div className="mt-3 space-y-2">
                <Select
                  value={panStatus}
                  onChange={setPanStatus}
                  className="w-full"
                >
                  <Option value="ok">OK</Option>
                  <Option value="deviation">Deviation</Option>
                </Select>
                {panStatus === "deviation" && (
                  <Input.TextArea
                    placeholder="Enter PAN deviation reason"
                    value={panReason}
                    onChange={(e) => setPanReason(e.target.value)}
                  />
                )}
              </div>
            </div>

            {/* Final Submit Button */}
            <div className="text-right">
              <Button
                type="primary"
                onClick={handleKycSubmit}
                disabled={
                  (aadhaarStatus === "deviation" && !aadhaarReason.trim()) ||
                  (panStatus === "deviation" && !panReason.trim())
                }
              >
                Submit KYC
              </Button>
            </div>
          </div>
        ) : (
          <p>Loading...</p>
        )}
      </Modal>
    </>
  );
}
